import { render, staticRenderFns } from "./dictionaryManage.vue?vue&type=template&id=a50104fa&scoped=true"
import script from "./dictionaryManage.vue?vue&type=script&lang=js"
export * from "./dictionaryManage.vue?vue&type=script&lang=js"
import style0 from "./dictionaryManage.vue?vue&type=style&index=0&id=a50104fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50104fa",
  null
  
)

export default component.exports